import React from "react";
import { Droppable } from "react-beautiful-dnd";
import { PolicyItem } from "../PolicyLibraryItem";
import Drage from "../../../icons/Draganddrop.svg?react";
import { getIconUrl } from "../../../iconUtils";
import styles from "./style.module.scss";


interface DropZoneProps {
  id: string;
  title: string;
  description: string;
  droppedItems: PolicyItem[];
  onClear: (itemId: string) => void;
  isSingle?: boolean;
  variant?: 'base' | 'compare';
}

const DropZone: React.FC<DropZoneProps> = ({
  id,
  title,
  description,
  droppedItems,
  onClear,
  isSingle = false,
  variant = 'base',
}) => {

  const hasItems = droppedItems.length > 0;

  return (
    <>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
      </div>
      <Droppable droppableId={id}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={`${styles.dropZone} ${snapshot.isDraggingOver ? styles.dragOver : ""} ${hasItems ? styles.hasItems : ""
              } ${hasItems && variant === 'compare' ? styles.compareVariant : ""}`}
          >
            {!hasItems ? (
              <div>
                <div className={styles.emptyState}>
                  <div className={styles.emptyImageContainer}><Drage className={styles.emptyImage} /></div>
                  <p className={styles.description}>{description}</p>
                </div>
                {isSingle && (
                  <div className={styles.validationContainer}>
                    <p className={styles.validationSinglePolicy}>
                      Only one policy can be selected as the base.
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.itemsContainer}>
                {isSingle && droppedItems.length > 0 && (
                  <div className={styles.singleItem}>
                    <div className={styles.policyCard}>
                      <button
                        className={styles.clearButton}
                        onClick={() => onClear(droppedItems[0].id)}
                        aria-label="Remove policy"
                      >
                        ×
                      </button>
                      <div className={styles.policyHeader}>
                        <div className={styles.iconContainer}>
                          {droppedItems[0]?.country && (
                            <img
                              src={getIconUrl(droppedItems[0]?.country.toLowerCase())}
                              alt={`${droppedItems[0].country} flag`}
                              style={{
                                width:
                                  droppedItems[0]?.name === "Cyber Security" ||
                                    droppedItems[0]?.name === "IT Management"
                                    ? "35px"
                                    : "40px",
                                height: "auto",
                              }}
                            />
                          )}
                        </div>
                        <div className={styles.policyInfo}>
                          <h4 className={styles.policyName}>
                            {droppedItems[0].name}
                          </h4>
                          {droppedItems[0].version && (
                            <span className={styles.version}>
                              {/* Version {droppedItems[0].version} */}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {!isSingle &&
                  droppedItems.map((item) => (
                    <div key={item.id} className={styles.compareCard}>
                      <button
                        className={styles.clearButton}
                        onClick={() => onClear(item.id)}
                        aria-label="Remove policy"
                      >
                        ×
                      </button>
                      <div className={styles.cardContent}>
                        <div className={styles.iconContainer}>
                          {item?.country && (
                            <img
                              src={getIconUrl(item?.country.toLowerCase())}
                              alt={`${item.country} flag`}
                              style={{
                                width:
                                  item?.name === "Cyber Security" ||
                                    item?.name === "IT Management"
                                    ? "30px"
                                    : "40px",
                                height: "auto",
                              }}
                            />
                          )}
                        </div>
                        <div className={styles.cardInfo}>
                          <h4 className={styles.cardName}>{item.name}</h4>
                          {item.version && (
                            <span className={styles.version}>
                              {/* Version {item.version} */}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
              </div>
            )}

            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </>
  );
};

export default DropZone;
